export const FETCH_SCENARIO_DATA = "FETCH_SCENARIO_DATA";
export const LOADER_STATE_FOR_SCENARIO = "LOADER_STATE_FOR_SCENARIO";
export const LOADER_STATE_SCENARIO_DATA = "LOADER_STATE_SCENARIO_DATA"
export const FETCH_MIX_SCENARIO_DATA = "FETCH_MIX_SCENARIO_DATA";
